export default "__VITE_ASSET__CZB_33Gq__"